import { render, staticRenderFns } from "./ExternalKeyboard.vue?vue&type=template&id=7c700ba0&"
import script from "./ExternalKeyboard.vue?vue&type=script&lang=js&"
export * from "./ExternalKeyboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports